import { Box, Typography } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { usePage } from 'contexts/Page/Page';
import { useMemo } from 'react';
import Image from '../Image/Image';

export default function Annotation({
    align,
    arrow,
    children,
    flip,
    index = 1,
    left = 0,
    lesson,
    top = 0,
    width,
}: AnnotationProps) {
    const content = useContent();
    const page = usePage();

    const arrowSrc = useMemo(() => {
        const direction = flip ? 'up' : 'down';
        return `/assets/icons/arrow-orange-curved-${direction}.svg`;
    }, [flip]);

    const arrowStyles = useMemo(() => {
        const [x, y, rotate, scale] = arrow.split(',');
        return {
            transform: `translate(${x || 0}px, ${y || 0}px) scale(${scale || 1}, 1) rotate(${rotate || 0}deg)`,
        };
    }, [arrow]);

    const label = useMemo(() => {
        const lessonIndex = lesson || page.lesson;
        const label = children || (lessonIndex && (content.lessons[lessonIndex] as any)?.[`annotation${index}`]) || '';
        return content.parseHtml(label);
    }, [children, content, index, lesson, page.lesson]);

    return (
        <Box left={left} position="absolute" top={top} width={width}>
            <Box position="absolute" sx={arrowStyles}>
                <Image alt="arrow" src={arrowSrc} />
            </Box>
            {label && (
                <Typography align={align} color="#FFF" margin={0} paragraph variant="roboto714">
                    {label}
                </Typography>
            )}
        </Box>
    );
}
